export const AUTH_ACCESS_TOKEN_COOKIE = "auth_access_token"
export const AUTH_REFRESH_TOKEN_COOKIE = "auth_refresh_token"
export const AUTH_USER_COOKIE = "auth_user"

export function getCookie(name: string): string | null {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "=([^;]*)")
  )
  return match ? decodeURIComponent(match[1]) : null
}

export function setSessionCookie(name: string, value: string): void {
  const encoded = encodeURIComponent(value)
  const secure = import.meta.env.PROD ? "; Secure" : ""
  document.cookie = `${name}=${encoded}; path=/; SameSite=Strict${secure}`
}

export function deleteCookie(name: string): void {
  const secure = import.meta.env.PROD ? "; Secure" : ""
  document.cookie = `${name}=; path=/; max-age=0; SameSite=Strict${secure}`
}
